import { z } from 'zod';
import { StreakSchema, TimeZoneSchema } from './common';

export const PublicUserSchema = z.object({
  id: z.uuid(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  timezone: z.string(),
});
export type PublicUser = z.infer<typeof PublicUserSchema>;

export const MeResponseSchema = z.object({
  user: PublicUserSchema,
  xp: z.object({ total: z.number().int().min(0), thisWeek: z.number().int().min(0) }),
  streak: StreakSchema,
});
export type MeResponse = z.infer<typeof MeResponseSchema>;

export const DisplayNameSchema = z
  .string()
  .trim()
  .min(2, 'Use at least 2 characters')
  .max(30, 'Use 30 characters or fewer');

export const UpdateMeRequestSchema = z
  .strictObject({
    displayName: DisplayNameSchema.optional(),
    timezone: TimeZoneSchema.optional(),
  })
  .refine((v) => v.displayName !== undefined || v.timezone !== undefined, {
    message: 'Nothing to update',
  });
export type UpdateMeRequest = z.infer<typeof UpdateMeRequestSchema>;
